import { LayoutDashboard, Users, Table2, Calculator, FileText, Printer, Tags, History, Settings, UserCog,
  Building2, ShieldCheck, ScrollText, Wallet, Scale, FilePen,
} from "lucide-react";

export const TENANT_NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, perm: "dashboard:read", tid: "nav-dashboard" },
  { to: "/pelanggan", label: "Data Pelanggan", icon: Users, perm: "customer:read", tid: "nav-data-pelanggan" },
  { to: "/rekap", label: "Rekap Penjualan Voucher", icon: Table2, perm: "recap:read", tid: "nav-rekap-penjualan" },
  { to: "/rekonsiliasi", label: "Rekonsiliasi Top Up", icon: Scale, perm: "topup:read", tid: "nav-rekonsiliasi" },
  { to: "/hutang", label: "Daftar Hutang", icon: Wallet, perm: "debt:read", tid: "nav-daftar-hutang" },
  { to: "/estimasi", label: "Estimasi Pembuatan Voucher", icon: Calculator, perm: "estimate:read", tid: "nav-estimasi-voucher" },
  { to: "/invoice", label: "Invoice Akhir", icon: FileText, perm: "invoice:read", tid: "nav-invoice-akhir" },
  { to: "/cetak", label: "Cetak Bulk Nota", icon: Printer, perm: "print:run", tid: "nav-cetak-bulk-nota" },
  { to: "/harga", label: "Daftar Harga Voucher", icon: Tags, perm: "price:read", tid: "nav-daftar-harga" },
  { to: "/riwayat", label: "Riwayat dan Laporan", icon: History, perm: "history:read", tid: "nav-riwayat" },
  { to: "/pengaturan", label: "Pengaturan Perusahaan", icon: Settings, perm: "company:read", tid: "nav-pengaturan" },
  { to: "/pengguna", label: "Manajemen Pengguna", icon: UserCog, perm: "user:manage", tid: "nav-pengguna" },
];

export const ADMIN_NAV = [
  { to: "/admin", label: "Dashboard Admin", icon: LayoutDashboard, perm: "platform:view", tid: "nav-admin-dashboard" },
  { to: "/admin/perusahaan", label: "Manajemen Perusahaan", icon: Building2, perm: "platform:manage", tid: "nav-admin-perusahaan" },
  { to: "/admin/pengguna", label: "Pengguna & Hak Akses", icon: ShieldCheck, perm: "platform:manage", tid: "nav-admin-pengguna" },
  { to: "/admin/revisi", label: "Permintaan Revisi", icon: FilePen, perm: "revision:approve", tid: "nav-admin-revisi", countUrl: "/revision-queue/count" },
  { to: "/admin/audit", label: "Audit Log", icon: ScrollText, perm: "platform:view", tid: "nav-admin-audit" },
  { to: "/admin/pengaturan", label: "Pengaturan Aplikasi", icon: Settings, perm: "platform:manage", tid: "nav-admin-pengaturan" },
];

export function homePath(s) {
  if (!s) return "/login";
  const perms = s.permissions;
  if (s.tenant) {
    const first = TENANT_NAV.find((i) => perms.includes(i.perm));
    return first ? first.to : "/";
  }
  if (perms.includes("platform:view")) return "/admin";
  if (perms.includes("platform:switch")) return "/pilih-perusahaan";
  return "/login";
}
